import * as React from 'react';
import { useSelector } from 'react-redux';
import { Base, DrawerContent } from '@gandi/ui';
import { selectNonBundledProducts, selectCartBundles, selectCartIsActive } from '../../../../modules/selectors';
import CartContentContext from '../../CartContentContext';
import BundleItem from './BundleItem';
import EmptyCart from './EmptyCart';
import ProductItem from './ProductItem';
import Suggestions from './Suggestions';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "bodyWrapper": "Body-bodyWrapper_1wOit",
  "container": "Body-container_nQ_m3"
};
function Body() {
  const products = useSelector(selectNonBundledProducts);
  const bundles = useSelector(selectCartBundles);
  const cartIsActive = useSelector(selectCartIsActive);
  const {
    noSuggestions
  } = React.useContext(CartContentContext);
  const showSuggestions = cartIsActive && !noSuggestions;
  return /*#__PURE__*/_jsx(DrawerContent, {
    children: products.length === 0 && bundles.length === 0 ? /*#__PURE__*/_jsx(EmptyCart, {}) : /*#__PURE__*/_jsxs(Base, {
      flex: true,
      flexCol: true,
      flexJustifyBetween: true,
      className: styles.bodyWrapper,
      children: [/*#__PURE__*/_jsxs("ul", {
        children: [products.map(product => /*#__PURE__*/_jsx(ProductItem, {
          product: product
        }, product.id)), bundles.map(bundle => /*#__PURE__*/_jsx(BundleItem, {
          bundle: bundle
        }, bundle.id))]
      }), showSuggestions && /*#__PURE__*/_jsx(Suggestions, {})]
    })
  });
}
export default Body;